import 'offline-js'
import 'offline-js/themes/offline-theme-dark.css'
import 'offline-js/themes/offline-language-persian.css'
import apiAddress from './APIEndPointAddress'

export default function offlineIndicator () {
  window.Offline.options = {
    checkOnLoad: true,
    checks: {xhr: {url: `${apiAddress}main/online`}}
  }
}



// WEBPACK FOOTER //
// ./src/utils/offlineIndicator.js